import * as React from 'react';
import PropTypes from 'prop-types';
var SvgSportsSnowNormalMedium = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M27.64 18.22L23 19.77 20 18v-4l3-1.75 4.61 1.56.32-.95-3.77-1.27 3.68-2.13-.5-.87-3.68 2.13.78-3.9-1-.2-1 4.77-3.05 1.76-3.48-2V7.59l3.65-3.21-.56-.75-3 2.63V2h-1v4.26l-3-2.63-.66.75L15 7.59v3.55l-3.48 2-3.06-1.78-1-4.77-1 .2.78 3.9-3.61-2.12-.5.87 3.68 2.13L3 12.83l.32.95L8 12.23 11 14v4l-3 1.77-4.64-1.55-.36.95 3.77 1.27-3.64 2.13.5.87 3.68-2.13-.78 3.9 1 .2 1-4.77 3.05-1.76 3.48 2v3.55l-3.65 3.21.66.75 3-2.63V30h1v-4.26l3 2.63.66-.75L16 24.41v-3.54l3.48-2 3.05 1.76 1 4.77 1-.2-.78-3.9 3.68 2.13.5-.87-3.68-2.13L28 19.17zM12 14l3.5-2 3.5 2v4l-3.5 2-3.5-2z"
  }));
});
SvgSportsSnowNormalMedium.defaultProps = {
  height: 32,
  width: 32
};
SvgSportsSnowNormalMedium.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgSportsSnowNormalMedium;